<template>
  <div>
    <div class="secondary-nav">
      <div class="font-weight-bold">
        {{ 'Choose Style' | trans }}
      </div>
      <div class="">
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{name:'StageInpaint', params: {uuid: id, activeStageId: activeStage.id}}"
        >
          <button class="btn-back btn text-white font-weight-bold" @click="navigate">
            <i class="fa lh-inherit fa-chevron-left"></i> {{ 'Back' | trans }}
          </button>
        </router-link>
      </div>
    </div>
    <div class="p-20 justify-content-center d-flex">
      <div class="content-container">
        <div class="style-group">
          <style-description></style-description>
          <style-selector></style-selector>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import StyleDescription from '../Elements/StyleDescription.vue';
import StyleSelector from '../Elements/StyleSelector.vue';

export default {
  name: 'StyleCanvas',
  props: {},
  components: {
    StyleSelector,
    StyleDescription,
  },
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {},
  created: function () {},
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.secondary-nav {
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: center;
  background: #2c2c2c;
  border-bottom: 1px solid #595959;
  padding: 0 20px;
  color: white;
}
.btn-back {
  background: #1266f1;
  display: flex;
  gap: 10px;
}
.content-container {
}

.style-group {
  gap: 30px;
  display: flex;
  flex-direction: column;
}
</style>
